export default "__VITE_PUBLIC_ASSET__00bad09b__"